import { AxiosPromise } from 'axios';
import client from '../core';

const consumeLaunch = (code: string): AxiosPromise<any> =>
  client.post('launch/consume', { code });

const generateTestUrl = (): AxiosPromise<{ launchUrl: string }> =>
  client.get('launch/generate-test-url');

export default {
  consumeLaunch,
  generateTestUrl,
};
